module.exports = __webpack_public_path__ + "assets/bin-icon.cdc4283d.svg";